import { getValidAccessToken, check401 } from "@utils/authenticatedFetch";
import { getApiOrigin } from "@utils/apiOrigin";

export interface Country {
  id: number;
  country_code: string;
  country_name: string;
  healthcare_system_type: string;
  primary_regulator: string;
  regulatory_framework_notes: string;
  currency_code: string;
  language_code: string;
}

export interface CountriesResponse {
  countries: Country[];
}

const COUNTRIES_API_BASE = getApiOrigin();
const COUNTRIES_PATH = '/api/v1/industry-compliance/countries';

export async function getCountries(): Promise<CountriesResponse> {
  try {
    const url = `${COUNTRIES_API_BASE}${COUNTRIES_PATH}`;
    const token = getValidAccessToken();
    const headers: Record<string, string> = {};
    if (token) {
      headers["Authorization"] = `Bearer ${token}`;
    }

    const response = await fetch(url, { method: "GET", headers });

    check401(response);

    if (!response.ok) {
      throw new Error(`Failed to fetch countries: ${response.statusText}`);
    }

    const data = await response.json();
    
    // Normalize to always return an array
    let countries: Country[] = [];
    if (Array.isArray(data)) {
      countries = data as Country[];
    } else if (data && Array.isArray((data as any).countries)) {
      countries = (data as any).countries as Country[];
    } else if (data && Array.isArray((data as any).results)) {
      countries = (data as any).results as Country[];
    } else {
      countries = [];
    }

    return { countries };
  } catch (error) {
    console.error('Error fetching countries:', error);
    throw new Error('Failed to load countries data');
  }
}


